import { get } from 'svelte/store';
import { devices } from '../lists/devices';
import { push } from 'svelte-spa-router';
import { drawerRedirect } from './sidepanel-public';
import { routeToDeviceSettings } from './route-to-device-settings';
import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';

export function navigateToSetting(id, setting = '', subSetting = '', gotoDeviceRoom = true, params) {
	if (setting === '' && subSetting === '') {
		return;
	}

	const device = get(devices)[id];

	if (device.room_id < 0) {
		push(`/home/devices/${device.room_id}`);
	} else if (gotoDeviceRoom) {
		push(`/home/room/${device.room_id}/devices`);
	}

	setSidePanelState({ type: 'device', id: device.id, open: true, showSettingsModal: true });
	routeToDeviceSettings.setTarget(id, setting, subSetting, params);
	drawerRedirect.set(true);
}

/**
 * Navigate to room thermostats page
 * @param {string} id - room id
 */
export function navigateToRoomThermostats(id) {
	//This is used inside RoomTempDrawerPreview.svelte in case user is disabled all room thermostats
	push(`/home/room/${id}/thermostats`);
	setSidePanelState({ type: 'room', id: id, open: false });
}

/**
 * Navigate to the device page within its room.
 * @param {string} id - The ID of the device.
 */
export const navigateToDevice = (id) => {
	if (typeof id !== 'string') return;
	const device = get(devices)[id];
	if (typeof device === 'undefined') return;
	push(`/home/room/${device.room_id}/devices`); //navigate to the room

	//set the drawer state with the device id and type
	//open the drawer
	setSidePanelState({ type: 'device', id: id, open: true });
};
